import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { injectIntl } from 'react-intl';

import EditContentPageForm from '../../../components/SiteAdmin/ContentPage/EditContentPageForm';
import NotFound from '../../../components/NotFound/NotFound';
import Loader from '../../../components/Common/Loader/Loader';

import editContentPage from './editContentPage.graphql';
import messages from '../../../locale/messages';

import s from './EditContentPage.css';

export class EditContentPage extends Component {

  static propTypes = {
    id: PropTypes.number.isRequired
  }
  static defaultProps = {
    editContentPageData: {
      loading: true
    }
  }

  render() {
    const { editContentPageData, editContentPageData: { loading } } = this.props;
    const { formatMessage } = this.props.intl;
    let title = formatMessage(messages.editContentLabel);

    if (loading) {
      return <Loader type={"page"} show={loading}></Loader>
    } else if (!editContentPageData?.editContentPage) {
      return <NotFound />;
    } else {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.heading}>
              {title}
            </div>
            <div className={s.paddingRoutesSection}>
              <EditContentPageForm
                title={title} initialValues={editContentPageData.editContentPage}
              />
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default compose(
  injectIntl,
  withStyles(s),
  graphql(editContentPage, {
    name: 'editContentPageData',
    options: (props) => ({
      variables: {
        id: props.id,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
  connect(mapStateToProps, mapDispatchToProps)
)(EditContentPage)
